import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react';
import { ProvidersApi } from '@internal/backstage-plugin-catalog-devops-react';

export class ProvidersApiClient
  extends DefaultApiClient
  implements ProvidersApi
{
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  async triggerProvider(providerType: string): Promise<DefaultApiResponse> {
    // POST: triggering a provider mutates state, so it must not be a GET.
    return await this.post('v2/provider/trigger', { providerType });
  }
}
